<div class="form-title">
    <span class="subtitle">{{title}}</span>
    <container-element  [ngSwitch]="viewMode">
      <span *ngSwitchCase="'popover'">
        <div class="rollup-down">
          <nb-icon class="arrowhead" icon="close-outline" #closeIcon (click)="togglePopover()"></nb-icon>
        </div>
      </span>
      <span *ngSwitchCase="'collapsible'">
        <ng-container *ngIf="open;else collapsed">
          <div class="rollup-down">
            <nb-icon class="arrowhead" icon="arrowhead-up-outline" #chevron (click)="toggleIcon()"></nb-icon>
          </div>
        </ng-container>
        <ng-template #collapsed>
          <div class="rollup-down">
            <nb-icon class="arrowhead" icon="arrowhead-down-outline" #chevron (click)="toggleIcon()"></nb-icon>
          </div>
        </ng-template>
      </span>
      <span *ngSwitchDefault>
        
      </span>
    </container-element>
    
    
  </div>
